import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import React from "react";
import { IconButton, Stack, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { HandleDataLayer } from "../../../Helpers";

export interface ModalContent {
  title: string;
  subtitle?: string;
  body: string;
}

interface SimpleContentModalProps {
  handleClose: (e: any) => void;
  modalOpen: boolean;
  content: ModalContent;
}

const useStyles = makeStyles<Theme, SimpleContentModalProps>((theme) => ({
  newPosOfDialog: {
    padding: 24,
    minHeight: 200,
    backgroundColor: "#FFFFFF",
    border: `2px solid ${theme.palette.divider}`,
    borderRadius: 15,
  },
  closeButton: {
    color: theme.palette.text.secondary,
  },
}));

export const SimpleContentModal = (props: SimpleContentModalProps) => {
  const classes = useStyles(props);
  const { handleClose, modalOpen, content } = props;
  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        classes={{
          paper: classes.newPosOfDialog,
        }}
        onClose={(e) => {
          handleClose(e);
        }}
        aria-labelledby="dialog-title"
        open={modalOpen}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems={"center"}
          sx={{ marginBottom: "16px" }}>
          <Typography variant="h4" sx={{ fontSize: "1.25rem" }}>
            {content.title}
          </Typography>
          <Tooltip
            placement="bottom-end"
            title="Close"
            arrow
            role="tooltip"
            describeChild>
            <IconButton
              onClick={(e) => {
                HandleDataLayer(
                  "modal",
                  "close",
                  "click",
                  "main content",
                  content.title,
                  "close cross",
                  "onclick"
                );
                handleClose(e);
              }}
              aria-label="close edit user account"
              className={classes.closeButton}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </Stack>
        <Stack
          direction={"column"}
          alignContent={"flex-start"}
          alignItems={"center"}
          gap={"16px"}
          sx={{ height: "100%", padding: "0px 8px" }}>
          <Typography
            variant={"h5"}
            sx={{
              marginRight: "auto",
              font: "normal normal bold 16px/24px Roboto",
              color: "#191919",
              textAlign: "left",
            }}>
            {content.subtitle}
          </Typography>
          <Typography
            variant={"body1"}
            component={"div"}
            sx={{
              font: "normal normal normal 16px/24px Roboto",
              whiteSpace: "pre-line",
              marginRight: "auto",
            }}>
            {content.body}
          </Typography>
        </Stack>
      </Dialog>
    </>
  );
};
